import { apiWebsocketURL } from "@/utils/env";

const INVESTOR_CHAT_WS_PATH = "deal-network/ws/investor-chat";

export type TInvestorChatSection =
  | "deal_pipeline"
  | "due_diligence"
  | "general_deal_pipeline"
  | "general_deal_stack"
  | "general_investor_chat";

export type TInvestorChatClientMessage =
  | { type: "investor_chat_message"; section: TInvestorChatSection; content: string; company_id?: string }
  | { type: "typing_indicator"; is_typing: boolean }
  | { type: "ping" };

export type TInvestorChatUserMessage = {
  type: "investor_chat_user_message";
  thread_id: string;
  content: string;
  timestamp: string;
};

export type TInvestorChatAIStatus = {
  type: "investor_chat_ai_status";
  thread_id: string;
  status: "thinking" | "complete" | "error";
  message: string;
  timestamp: string;
};

export type TInvestorChatAIResponse = {
  type: "investor_chat_ai_response";
  thread_id: string;
  content: string;
  usage_stats?: Record<string, unknown>;
  total_cost?: number;
  timestamp: string;
};

export type TInvestorChatErrorMessage = {
  type: "error";
  code?: string;
  message: string;
};

export type TInvestorChatPresenceUpdate = {
  type: "presence_update";
  thread_id: string;
  presence: { user_id: string; last_seen: string }[];
};

export type TInvestorChatPong = {
  type: "pong";
};

export type TInvestorChatTypingIndicator = {
  type: "typing_indicator";
  user_id: string;
  is_typing: boolean;
};

export type TInvestorChatThreadHistoryMessage = {
  id: string;
  content: string;
  sender_id?: string | null;
  user_id?: string | null;
  message_type: string;
  created_at?: string | null;
  files?: { id: string; name: string | null; url?: string | null }[] | null;
};

export type TInvestorChatThreadHistory = {
  type: "investor_chat_thread_history";
  thread_id: string;
  messages: TInvestorChatThreadHistoryMessage[];
};

export type TInvestorChatServerMessage =
  | TInvestorChatUserMessage
  | TInvestorChatAIStatus
  | TInvestorChatAIResponse
  | TInvestorChatErrorMessage
  | TInvestorChatPresenceUpdate
  | TInvestorChatPong
  | TInvestorChatTypingIndicator
  | TInvestorChatThreadHistory;

export const investorChatService = {
  getWebSocketURL(threadId: string, token: string, investorCompanyId: string): string {
    const url = apiWebsocketURL(`${INVESTOR_CHAT_WS_PATH}/${threadId}`);
    url.searchParams.set("token", token);
    url.searchParams.set("investor_company_id", investorCompanyId);
    return url.toString();
  },
};
